/**
 * How a form is rendered
 */
// oxlint-disable-next-line eslint/no-redeclare
export const FormRenderMode = {
	/**
	 * Render a form with all fields as input elements
	 */
	EDIT: 'edit',
	/**
	 * Render a form with all fields as disabled input elements
	 */
	PREVIEW: 'preview',
	/**
	 * Render a form with all field values as plain text
	 */
	VIEW: 'view',
} as const;

export type FormRenderMode = (typeof FormRenderMode)[keyof typeof FormRenderMode];
